// @flow
import { hideDialog, openDialog } from '../../../../../react/features/base/dialog/actions';
import { showNotification } from '../../../../../react/features/notifications/actions';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal } from '../../../../components/base/modal';
import PopupNotification from '../../../../components/modals/PopupNotification';
import PopupRejoin from '../../../../components/modals/PopupRejoin';
import { PopupAlone } from '../../../../components/popup-alone';
import WildixEvents from '../../../../service/WildixEvents';

const dialogList = {
    'PopupNotification': PopupNotification,
    'PopupRejoin': PopupRejoin,
    'PopupAlone': PopupAlone
};

/**
 * @public
 */
type Props = {
    children: Array<any>,
    openDialog: Function<any>,
    showNotification: Function<any>,
    hideDialog: Function<any>,
    dialog: Object<any>
};

class AppWrapper extends PureComponent<Props> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this._addListeners();
    }

    componentWillUnmount() {
        this._removeListeners();
    }

    _addListeners() {
        APP.wildix.eventEmitter.on(WildixEvents.SHOW_NOTIFICATION, this._handleShowNotification);
        APP.wildix.eventEmitter.on(WildixEvents.OPEN_DIALOG, this._handleOpenDialog);
        APP.wildix.eventEmitter.on(WildixEvents.HIDE_DIALOG, this._handleHideDialog);
    }

    _removeListeners() {
        APP.wildix.eventEmitter.off(WildixEvents.SHOW_NOTIFICATION, this._handleShowNotification);
        APP.wildix.eventEmitter.off(WildixEvents.OPEN_DIALOG, this._handleOpenDialog);
        APP.wildix.eventEmitter.off(WildixEvents.HIDE_DIALOG, this._handleHideDialog);
    }

    _handleShowNotification = (notificationData, timeout) => {
        this.props.showNotification(notificationData, timeout);
    };

    _handleOpenDialog = (name, data) => {
        if (this.props.dialog.component === dialogList[name]) {
            return;
        }

        this.props.openDialog(dialogList[name], data);
    };

    _handleHideDialog = name => {
        this.props.hideDialog(dialogList[name]);
    };

    render() {
        const children = React.Children.toArray(this.props.children);

        children.push(<Modal key={children.length}/>);

        return children;
    }
}


/**
 * Maps (parts of) the redux state to the associated props for this component.
 *
 * @param {Object} state - The Redux state.
 * @param {Props} ownProps - The own props of the Component.
 * @private
 * @returns {Props}
 */
export function _mapStateToProps(state) {
    return {
        dialog: state['features/base/dialog']
    };
}


/**
 * Maps dispatching of some action to React component props.
 *
 * @param {Function} dispatch - Redux action dispatcher.
 * @private
 * @returns {{
 *     showCustomNotification: Function,
 *     hideCustomNotification: Function
 * }}
 */

export function _mapDispatchToProps(dispatch) {
    return {
        showNotification: (data, timeout) => dispatch(showNotification(data, timeout)),
        openDialog: (component, data) => dispatch(openDialog(component, data)),
        hideDialog: component => dispatch(hideDialog(component))
    };
}


export default connect(_mapStateToProps, _mapDispatchToProps)(AppWrapper);
